import React, { Component } from 'react';

import { withRouter } from "react-router-dom";

import "../design/projecttasks.css";

class TagList extends Component {

    constructor(props) {
        super(props);
        this.handleRedirectToTask = this.handleRedirectToTask.bind(this);
    }

    handleRedirectToTask(event, tagUUID) {
        event.preventDefault();
        if (event.ctrlKey === true) {
            var win = window.open("/Project/" + this.props.projectUUID + "/Tag/" + tagUUID, '_blank');
            win.focus();
        }
        else {
            this.props.history.push("/Project/" + this.props.projectUUID + "/Tag/" + tagUUID);
        }
    }

    render() {
        const tags = this.props.tags;
        if (!tags) return null;

        return (
            <div>
                <table>
                    <thead>
                        <tr>
                            <td>Tag name</td>
                            <td>Tag Released</td>
                        </tr>
                    </thead>
                    <tbody>
                        {tags.map((tag) => (
                            <tr className="tr_hover"
                                key={tag.releaseTagUUID}
                                onClick={(event) => { this.handleRedirectToTask(event, tag.releaseTagUUID) }}
                            >
                                <td>{tag.releaseName}</td>
                                <td>{(tag.releasedTime !== null ? tag.releasedTime : "Not Released")}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withRouter(TagList);


// WEBPACK FOOTER //
// ./src/components/tagList.js